/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Requirement/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Requirement({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/AppointmentRequirements/Content/Content/Content/Requirement"
  
}) {
let eventActionDataRequirementsValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.requirements',
})
let requirementIdValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'id',
})
let aggregateData = fromHelpers.isEnabled(eventActionDataRequirementsValueData, requirementIdValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let requirementNameValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'name',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 width={240}
 data="event_action.data.requirements"
 data="requirement.id"
 aggregate="./helpers.js isEnabled"
 value={aggregateData}
 onChange={onChange}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 size="medium"
 data="requirement.name"
 text={requirementNameValueData}
/>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 marginLeft="auto"
 marginRight={0}
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}